import React, { useState } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardSection,
  Gutter,
  ImageCircle,
  Layout,
  LayoutItem,
  Paragraph,
  ParagraphHeader,
  SmallHeader,
  Visible,
} from '@axiom/ui';
import type { Candidate } from '@axiom/validation';

import { CandidateUtil } from '../../utils/candidate-util';
import { SupportContactsModal } from '../SupportContactsModal/SupportContactsModal';

export const ProfileTalentPartner = ({
  candidate,
}: {
  candidate: Candidate;
}) => {
  const [supportModal, setSupportModal] = useState(false);
  const user = CandidateUtil.getTalentPartnerUser(candidate);
  const name = `${user.firstName || ''} ${user.lastName || ''}`.trim();

  return (
    <>
      <Card name="PROFILE_TALENT_PARTNER_CARD">
        <CardHeader>
          <SmallHeader name="PENDO_PROFILE_TALENT_PARTNER_HEADER">
            Get Support
          </SmallHeader>
        </CardHeader>
        <CardSection name="PROFILE_TALENT_SUPPORT_SECTION" divider>
          <Layout direction="vertical">
            <LayoutItem bottomGutter="16px">
              <Paragraph>
                Support is here when you need it - from IT and timesheets to
                your Opportunity Feed and beyond.
              </Paragraph>
            </LayoutItem>
            <LayoutItem position="right">
              <Button
                name="GET_SUPPORT_BUTTON"
                pattern="secondary"
                onClick={() => {
                  setSupportModal(prev => !prev);
                }}
              >
                Get Support
              </Button>
            </LayoutItem>
          </Layout>
        </CardSection>
        <CardSection name="PROFILE_TALENT_PARTNER_SECTION">
          <ParagraphHeader>Your Talent Success Partner</ParagraphHeader>
          <Gutter bottom="16px" />
          <Layout position="middle" horizontalGutter="16px">
            <Visible only="largeScreen">
              <ImageCircle
                name="TALENT_PARTNER_IMAGE"
                size="small"
                imageName={name}
              />
            </Visible>
            <div>
              <div data-test="TALENT_PARTNER_NAME">{name}</div>
            </div>
          </Layout>
        </CardSection>
      </Card>
      {supportModal ? (
        <SupportContactsModal
          user={user}
          name={name}
          onClose={() => {
            setSupportModal(false);
          }}
        />
      ) : null}
    </>
  );
};
